/**
 * @file useLabelCutLines.ts
 * @description Настройка «Линии реза» — пунктир по границе наклеек в PDF
 *   (phase19.22 шаг 5, решение пользователя 2026-09-26).
 *
 * Пока нет принтера этикеток, этикетки печатают на обычной бумаге и режут
 * ножницами — пунктир показывает, где резать. На самоклейке он не нужен.
 * Выбор принадлежит рабочему месту (какая бумага в этом принтере), а не
 * складу: живёт в `localStorage` этого браузера, по умолчанию выключен.
 * Один флаг на печать товара и печать ячеек — бумага в принтере одна.
 */

import { useSyncExternalStore } from "react";

import { createDeviceFlag } from "../../../lib/device-flag";

/** Флаг устройства «Линии реза». */
export const labelCutLinesFlag = createDeviceFlag("chaiberi.admin.labels.cutLines", false);

const serverSnapshot = (): boolean => labelCutLinesFlag.defaultValue;

export function useLabelCutLines(): [boolean, (value: boolean) => void] {
  const value = useSyncExternalStore(labelCutLinesFlag.subscribe, labelCutLinesFlag.get, serverSnapshot);
  return [value, labelCutLinesFlag.set];
}
